import { render, staticRenderFns } from "./DoctorOrdersList.vue?vue&type=template&id=cc79b0a6&"
import script from "./DoctorOrdersList.vue?vue&type=script&lang=js&"
export * from "./DoctorOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports